import styled from 'styled-components'

export const StyledApp = styled.div`
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  align-content: center;
`

StyledApp.displayName = 'StyledApp'



// WEBPACK FOOTER //
// ./src/app/StyledApp.js